import GeneratedHttpThunk from 'utility/redux/generatedHttpThunk';

const cmEnrollmentRangeHttpRequest = (() => {
  const apiName = 'cmEnrollmentRange';
  const generatedHttpThunk = new GeneratedHttpThunk(apiName);
  generatedHttpThunk.resource = `filter/month-range`;
  return generatedHttpThunk.generatePortfolioThunk();
})();

export default cmEnrollmentRangeHttpRequest;
